import { render, staticRenderFns } from "./ProgramGroupsSelectbox.vue?vue&type=template&id=6dbd7ac4&"
import script from "./ProgramGroupsSelectbox.vue?vue&type=script&lang=js&"
export * from "./ProgramGroupsSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports